"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PurchasesAPIError_code, _PurchasesAPIError_message, _PurchasesAPIError_payload;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasesAPIError = exports.PurchasesAPIErrorCode = void 0;
var PurchasesAPIErrorCode;
(function (PurchasesAPIErrorCode) {
    /**
     * Might be @deprecated
     */
    PurchasesAPIErrorCode["BundleDoesNotExist"] = "Bundle.DoesNotExist";
    PurchasesAPIErrorCode["EmptyDuration"] = "empty_duration";
    PurchasesAPIErrorCode["InvalidLicenceFrom"] = "invalid_licence_from";
    PurchasesAPIErrorCode["Expired"] = "expired";
    PurchasesAPIErrorCode["AlreadyActivated"] = "already_activated";
    PurchasesAPIErrorCode["InvalidCode"] = "invalid_code";
    PurchasesAPIErrorCode["InvalidDomain"] = "invalid_domain";
    PurchasesAPIErrorCode["MaxCountReached"] = "max_count_reached";
})(PurchasesAPIErrorCode || (exports.PurchasesAPIErrorCode = PurchasesAPIErrorCode = {}));
class PurchasesAPIError extends Error {
    constructor(code, message, payload) {
        super();
        _PurchasesAPIError_code.set(this, void 0);
        _PurchasesAPIError_message.set(this, void 0);
        _PurchasesAPIError_payload.set(this, void 0);
        __classPrivateFieldSet(this, _PurchasesAPIError_code, code, "f");
        __classPrivateFieldSet(this, _PurchasesAPIError_message, message, "f");
        __classPrivateFieldSet(this, _PurchasesAPIError_payload, payload, "f");
    }
    get code() {
        return __classPrivateFieldGet(this, _PurchasesAPIError_code, "f");
    }
    get message() {
        return __classPrivateFieldGet(this, _PurchasesAPIError_message, "f");
    }
    get payload() {
        return __classPrivateFieldGet(this, _PurchasesAPIError_payload, "f");
    }
}
exports.PurchasesAPIError = PurchasesAPIError;
_PurchasesAPIError_code = new WeakMap(), _PurchasesAPIError_message = new WeakMap(), _PurchasesAPIError_payload = new WeakMap();
